<template>
  <v-list-item
    :href="href"
    :rel="href && href !== '#' ? 'noopener' : undefined"
    :target="href && href !== '#' ? '_blank' : undefined"
    :to="item.to"
    v-if="checkListPermission(item)"
    :title="item.title"
  >
    <v-list-item-icon v-if="item.icon">
      <v-icon v-text="item.icon" />
    </v-list-item-icon>

    <v-list-item-content v-if="item.title">
      <!-- <v-list-item-title v-text="item.title" /> -->
      <v-list-item-title :title="item.title">
        <div
          style="
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: normal;
          "
        >
          {{ item.title }}
        </div>
        <div
          v-if="item.sub_title"
          style="
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: normal;
            opacity: 0.6;
            font-size: 0.8rem;
          "
        >
          {{ item.sub_title }}
        </div>
      </v-list-item-title>
    </v-list-item-content>

    <v-list-item-action v-if="item.title == 'Approval' && mission > 0">
      <v-chip color="red" small dark>{{ mission }}</v-chip>
    </v-list-item-action>
    <v-list-item-action v-else-if="item.title == 'Chat Center' && chatRoom > 0">
      <v-chip color="red" small dark>{{ chatRoom }}</v-chip>
    </v-list-item-action>
  </v-list-item>
</template>

<script>
import Themeable from "vuetify/lib/mixins/themeable";
import { mapState } from "vuex";

export default {
  name: "BaseItem",

  mixins: [Themeable],

  props: {
    item: {
      type: Object,
      default: () => ({
        href: undefined,
        icon: undefined,
        title: undefined,
        to: undefined,
      }),
    },
    text: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    mission: 0,
    chatRoom: 0,
  }),

  computed: {
    ...mapState("defaultSystem", ["user"]),
    href() {
      return this.item.href || (!this.item.to ? "#" : undefined);
    },
    checkListPermission() {
      return ({ to }) => {
        if (
          ["/reward/partner-integrate", "/reward/reward-partner"].includes(to)
        ) {
          let check = false;
          if (Array.isArray(this.user?.partner)) {
            const model = this.user.partner.find((x) => x.type == "reward");
            check = model ? true : false;
          }
          return check;
        } else {
          return true;
        }
      };
    },
  },
  created() {
    setTimeout(() => {
      const noti = JSON.parse(localStorage.getItem("noti"));
      this.mission = noti.activity;
      this.chatRoom = noti.chat_room;
    }, 100);
  },
  methods: {},
};
</script>
